import { Injectable } from '@angular/core';
import { SidebarEntity } from '@app-core/data/sidebar.data';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { availableRoutes } from '@modules/home/routes.model';
import { BehaviorSubject } from 'rxjs';
import { UserPrincipalService } from './user-principal.service';

@Injectable()
export class SidebarService {

  public sideNavOpenStatus$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(private userService: UserPrincipalService) {
  }

  private availableItems: SidebarEntity[] = availableRoutes.map(({path, data}) => {
    return new SidebarEntity(data.scopeName, _(`SIDEBAR.${ data.title }`), ['/', path], data.icon);
  });

  public getMenuItems(): Promise<SidebarEntity[]> {
    return new Promise<SidebarEntity[]>(resolve => {
      const menuItems = this.userService.userAccess.map(access => access.name);
      const result = this.availableItems.filter(item =>
        menuItems.includes(item.name));

      resolve(result);
      console.count(JSON.stringify(this.userService.userAccess)); // todo: don't forget to remove
    });
  }
}
